import { email } from 'ccmag-utils/validators.js';

export const extractSearchParams = (searchParams: URLSearchParams) => ({
  email: searchParams.get('e'),
  token: searchParams.get('t'),
});

export const validateEmail = (maybeEmail: string) => {
  return email(maybeEmail);
};
